// extracted by mini-css-extract-plugin
export default {"container":"SwipeMenu1_container__1Zw3-","scroll":"SwipeMenu1_scroll__mWj0w","navitem":"SwipeMenu1_navitem__QxDbU"};